import React, { useContext, useEffect, useState } from 'react';
import { contentfulPropTypes, onboardingPropTypes } from '../../propTypes';

import { Button } from 'react-bootstrap';
import { ConsentContext } from '../../context/ConsentContext';
import EditAddressModal from '../../ui/Modal/EditAddressModal';
import LoopSpinner from '../../ui/LoopSpinner';
import OnboardingDeleteAccountModal from '../../ui/Modal/DeleteAccount/OnboardingDeleteAccountModal';
import PropTypes from 'prop-types';
import { SpacerHr } from '../../ui/Styled';
import errorDisc from '../../assets/svg/disc/error-disc.svg';
import { formatMpanForDisplay } from '../../utils/formatMpanUtil';
import { getTodayDateString } from '../../utils/getTodayDateString';
import { parseAddressString } from '../../utils/parseAddress';
import { replaceContentfulDelimiter } from '../../utils/replaceContentfulDelimiter';
import styled from 'styled-components';
import { useNavigate } from 'react-router';

const DetailsContainer = styled.div`
  border: 1px solid grey;
  border-radius: 4px;
  text-align: left;
  padding: 8px 10px;
  margin: 20px 0 22px;
`;

const ChangeContainer = styled.div`
  font-size: 12px;
  margin-bottom: 18px;
`;

const ConfirmAddressContainer = ({
  contentful,
  user,
  userDetails,
  isRequired,
}) => {
  const [showEditAddressForm, setShowEditAddressForm] = useState(false);
  const {
    setMpan,
    showDeleteAccountModal,
    setShowDeleteAccountModal,
    setIsDeleting,
    deleteError,
    setDeleteError,
    isDeleting,
    setReconfirmLastSeen,
  } = useContext(ConsentContext);

  const reconsentDue = userDetails?.consent?.reconsent_due;
  const formattedDate = new Date(reconsentDue * 1000).toLocaleDateString(
    'en-GB',
    {
      day: 'numeric',
      month: 'long',
    },
  );
  const navigate = useNavigate();
  useEffect(() => {
    !!userDetails?.meters?.electricity?.mpxn &&
      setMpan(userDetails?.meters?.electricity?.mpxn);
  }, [userDetails]); // eslint-disable-line react-hooks/exhaustive-deps
  const showAddressAndMpan =
    !!user?.attributes?.address && !!userDetails?.meters?.electricity?.mpxn;
  const body = replaceContentfulDelimiter(
    contentful?.body,
    '{date}',
    <strong>{formattedDate}</strong>,
  );
  return (
    <>
      <EditAddressModal
        show={showEditAddressForm}
        onHide={() => setShowEditAddressForm(false)}
      />
      <OnboardingDeleteAccountModal
        show={showDeleteAccountModal}
        onHide={() => setShowDeleteAccountModal(false)}
        setIsDeleting={setIsDeleting}
        deleteError={deleteError}
        setDeleteError={setDeleteError}
        initialReason="Didn't complete onboarding"
      />
      <p>
        <img src={errorDisc} alt="Warning" />
      </p>
      <h1 className="pb-3">{contentful?.subtitle}</h1>
      {showAddressAndMpan ? (
        <>
          <p>{body}</p>
          {contentful?.bodyEnd && (
            <Button
              className="mb-0 mt-0 pt-0 w-100"
              href={contentful.link}
              variant="link">
              {contentful.bodyEnd}
            </Button>
          )}
          <DetailsContainer>
            <>
              <div className="pb-2">
                <strong>Address:</strong>{' '}
                {parseAddressString(user?.attributes?.address)}
              </div>
              <div>
                <strong>MPAN:</strong>{' '}
                {formatMpanForDisplay(userDetails?.meters?.electricity?.mpxn)}
              </div>
            </>
          </DetailsContainer>
        </>
      ) : (
        <div>
          <LoopSpinner />
          <p></p>
        </div>
      )}
      <ChangeContainer>
        Changed your address or MPAN?{' '}
        <Button
          variant="inline-link"
          size={'sm'}
          disabled={!showAddressAndMpan}
          onClick={() => setShowEditAddressForm(true)}>
          Update it here.
        </Button>
      </ChangeContainer>
      {contentful?.primaryButtonText && (
        <Button
          className="mb-0 mt-2 w-100"
          onClick={() => navigate('/reconfirm/terms')}
          disabled={!showAddressAndMpan}>
          {contentful.primaryButtonText}
        </Button>
      )}
      {!isRequired && contentful?.secondaryButtonText ? (
        <Button
          className="mb-0 mt-2 w-100"
          onClick={() => {
            setReconfirmLastSeen(getTodayDateString());
            navigate('/account');
          }}
          variant="link">
          {contentful.secondaryButtonText}
        </Button>
      ) : (
        contentful.secondaryButtonText && (
          <div className="mt-3">
            <SpacerHr label="or" />
            <div>{contentful.utilityText}</div>
            <Button
              variant="inline-link"
              className="mb-0 mt-1"
              onClick={() => setShowDeleteAccountModal(true)}
              disabled={isDeleting}>
              {contentful.secondaryButtonText}
            </Button>
          </div>
        )
      )}
    </>
  );
};

ConfirmAddressContainer.propTypes = {
  ...contentfulPropTypes,
  ...onboardingPropTypes,
  meters: PropTypes.shape({
    electricity: PropTypes.shape({
      mpxn: PropTypes.number,
    }),
  }),
  isRequired: PropTypes.bool,
};

ConfirmAddressContainer.defaultProps = {
  isRequired: false,
};

export default ConfirmAddressContainer;
